import React from "react";
import { Clock3, LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";
import AuthLayout from "./components/AuthLayout";
import { clearAuthFlow, clearAuthSession } from "./components/authStore";
import AuthPopup from "./components/AuthPopup";

export default function WaitingApproval() {
  const nav = useNavigate();

  const onLogout = () => {
    clearAuthFlow();
    clearAuthSession();
    nav("/admin/login", { replace: true });
  };

  return (
    <AuthLayout>
      <div className="mx-auto w-full max-w-[430px] rounded-[24px] border border-[#f6d8dd] bg-white p-6 text-center shadow-[0_20px_70px_rgba(216,106,120,0.12)] sm:p-8">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[#fff3f5] text-[#d86a78]">
          <Clock3 size={32} />
        </div>

        <h1 className="mt-5 text-[30px] font-bold tracking-wide text-[#d86a78]">WAITING FOR APPROVAL</h1>
        <p className="mt-3 text-[14px] leading-6 text-slate-500">
          Your onboarding request has been sent to admin.
          <br />
          You will be able to login after admin approval.
        </p>

        <div className="mt-6 rounded-[16px] border border-[#f6d8dd] bg-[#fff8f9] px-4 py-3 text-left text-[13px] text-slate-500">
          <div>1. Admin reviews your onboarding details.</div>
          <div className="mt-2">2. After approval, login again with your new password.</div>
        </div>

        <button
          type="button"
          onClick={onLogout}
          className="mt-6 inline-flex h-[44px] w-full items-center justify-center gap-2 rounded-[10px] bg-[#d86a78] text-[13px] font-semibold text-white hover:bg-[#c95b69]"
        >
          <LogOut size={16} />
          Logout
        </button>
      </div>
    </AuthLayout>
  );
}